package org.matthewo.recharts.type

object LegendType {

    val line: LegendType
        get() = "line".unsafeCast<LegendType>()

    val plainline: LegendType
        get() = "plainline".unsafeCast<LegendType>()

    val square: LegendType
        get() = "square".unsafeCast<LegendType>()

    val rec: LegendType
        get() = "rec".unsafeCast<LegendType>()

    val circle: LegendType
        get() = "circle".unsafeCast<LegendType>()

    val cross: LegendType
        get() = "cross".unsafeCast<LegendType>()

    val diamond: LegendType
        get() = "diamond".unsafeCast<LegendType>()

    val star: LegendType
        get() = "star".unsafeCast<LegendType>()

    val triangle: LegendType
        get() = "triangle".unsafeCast<LegendType>()

    val wye: LegendType
        get() = "wye".unsafeCast<LegendType>()

    val none: LegendType
        get() = "none".unsafeCast<LegendType>()
}
